import { useQueryClient } from '@tanstack/react-query'
import { ArrowRight } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import LinkButton from '@/components/ui/link-button'
import { useUpdateOnboardingStep } from 'app/frontend/base/config/mutations'

interface Props {
  team: wowaudit.Team
  guild: wowaudit.Guild
}

const OnboardingResumeBanner = ({ team, guild }: Props) => {
  const queryClient = useQueryClient()
  const { mutate, isPending } = useUpdateOnboardingStep(team.id)

  const resumePath = `${guild.path}/onboarding?step=${team.onboardingStep}&team=${team.id}`

  const dismiss = () => {
    mutate(null, {
      onSuccess: () =>
        queryClient.invalidateQueries({
          queryKey: ['team', { path: team.path }],
        }),
    })
  }

  return (
    <Alert variant='info' className='mb-6'>
      <AlertTitle>Finish setting up your team</AlertTitle>
      <AlertDescription className='flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
        <span>
          You haven&apos;t completed the setup for this team yet. Pick up where
          you left off!
        </span>
        <div className='flex shrink-0 items-center gap-2'>
          <Button
            variant='ghost'
            size='sm'
            onClick={dismiss}
            loading={isPending}
          >
            Dismiss
          </Button>
          <LinkButton
            to={resumePath}
            variant='outline'
            size='sm'
            className='gap-2'
          >
            Continue setup
            <ArrowRight className='h-4 w-4' />
          </LinkButton>
        </div>
      </AlertDescription>
    </Alert>
  )
}

export default OnboardingResumeBanner
